import { NavigationMenus } from '../../../entities';
import { GlobalNavigationConfig } from '../../../entities';

export const IndiaConfig: GlobalNavigationConfig = {
  footerVariant: 'simple',
  headerVariant: 'simple',
  logoVariant: 'india',
  menu: {
    copyright: [],
    footer: [],
    header: { primary: [], secondary: [] } as NavigationMenus,
  },
};
